import { FilterOperator, IInsurancePolicyFilterCriteria, InsurancePolicyFilterProperty } from '@ViewModels';
import moment from 'moment';

export interface IRenewalChartLabels {
	overTimeTitle: string;
	distributionTitle: string;
	byCarrierTitle: string;
	subtitle: string;
	includesPastRenewals: boolean;
}

const SOURCE = 'from the Renewal Date filter';

const formatDate = (date: string) => moment(date).format('MMM D, YYYY');

const describeRange = (from?: string, to?: string) => {
	if (from && to) {
		return `Renewing ${formatDate(from)} – ${formatDate(to)}, ${SOURCE}`;
	}
	if (from) {
		return `Renewing after ${formatDate(from)}, ${SOURCE}`;
	}
	if (to) {
		return `Renewing before ${formatDate(to)}, ${SOURCE}`;
	}
	return 'All renewal dates';
};

/** "Upcoming" is only true when the filter cannot reach a renewal date before today. */
export const getRenewalChartLabels = (
	criteria: IInsurancePolicyFilterCriteria[],
	today = moment().format('YYYY-MM-DD')
): IRenewalChartLabels => {
	const renewalCriteria = criteria.filter(c => c.property === InsurancePolicyFilterProperty.RenewalDate && c.value);
	const from = renewalCriteria.find(c => c.op === FilterOperator.Gt)?.value;
	const to = renewalCriteria.find(c => c.op === FilterOperator.Lt)?.value;
	// Gt is exclusive: "after yesterday" already starts today.
	const upcomingOnly = Boolean(from && moment(from).add(1, 'day').isSameOrAfter(today, 'day'));
	const prefix = upcomingOnly ? 'Upcoming ' : '';

	return {
		overTimeTitle: `${prefix}Renewals by Month`,
		distributionTitle: `${prefix}Renewals by Premium Range`,
		byCarrierTitle: `${prefix}Renewal Premium by Carrier`,
		subtitle: describeRange(from, to),
		includesPastRenewals: !upcomingOnly,
	};
};
